import {
    Component,
    ChangeDetectionStrategy,
    ViewChild,
    Input,
    Type,
    Output,
    EventEmitter, OnChanges,
} from '@angular/core';
import { PopupContentDirective } from '../../directives/popup-content.directive';
import { MapItemComponent, MapItem } from '@ui/shared/util-map';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-sidebar-raster-item',
    templateUrl: './map-sidebar-raster-item.component.html',
    styleUrls: ['./map-sidebar-raster-item.component.scss'],
    standalone: false,
})
export class MapSidebarRasterItemComponent<MapItemType extends MapItem> implements OnChanges {
    @Input()
    public mapItem!: MapItemType;

    @Input()
    public gridContentComponentType!: Type<MapItemComponent<MapItemType>>;

    @Output()
    public readonly mapItemClicked = new EventEmitter<MapItemType>();

    @ViewChild(PopupContentDirective, { static: true })
    public uiPopupContentHost?: PopupContentDirective;

    public loadPopupContent(): void {
        if (!this.uiPopupContentHost) {
            return;
        }

        const viewContainerRef = this.uiPopupContentHost.viewContainerRef;

        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(this.gridContentComponentType);

        componentRef.setInput('mapItem', this.mapItem);
        componentRef.instance.isInSidebar = true;
    }

    public ngOnChanges(): void {
        this.loadPopupContent();
    }
}
